<template>
    <div id="app">
<!--        <router-view />-->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style lang="scss">
@import "../common/css/main.css";
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    // color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue